<template>
  <div>
  <b-card class="shadow-lg">
    <h5 class="mb-3">設定密碼</h5>
    <p>設置密碼後可使用手機帳號及密碼登入</p>
    <b-row>
    <b-col>
      <label>已驗證手機<span class="text-danger">*</span></label>
      <b-form-input  type="text" v-model="Username" readonly ></b-form-input>
    </b-col>
    <b-col>
      <b-form-group description="">
        <label>密碼<span class="text-danger">*</span></label>
        <b-input-group >
          <b-form-input

                  name="password"
                  v-model="formData.password"
                  type="password"
                  maxlength="12"
                  required
                  @change="checkvalue('password')"
                  placeholder="輸入密碼"
                  autocomplete="password"
          ></b-form-input>
          <b-input-group-append >
            <b-button  variant="primary" @click="savePwd" :disabled="sendloading" ><b-spinner v-if="sendloading" small label="Spinning"></b-spinner> 送出</b-button>
          </b-input-group-append>
          <b-form-invalid-feedback :state="formData.passwordcheck">
            {{ formData.passwordmsg }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
    </b-col>
    </b-row>


  </b-card>
  <hr>
  </div>
</template>
<style>

</style>

<script>
import {mapState} from 'vuex'
import { alertModel } from '@/service/commuse'

export default {
  name: 'BindAccount',
  components: {},
  props: {
    Username:String

  },


  data () {
    return {
      formData: {
        verifcode:'',
        verifcodecheck:null,
        verifcodemsg:'',
        username: '',
        usernamecheck: null,
        usernamemsg: '',
        password: '',
        passwordcheck: null,
        passwordmsg: '',
        firstname: '',
        lastname: '',
        namecheck: null,
        namemsg: '',
        email: '',
        emailcheck: null,
        emailmsg: '',
        male: 0,
        malecheck: null,
        malemsg: '',
        PromotionCode: '',
        installLocation: ''
      },
      smsbtn:true,
      sendloading:false
    }
  },
  mounted() {

  },
  methods: {
    checkvalue (way) {
      switch (way) {

        case 'verifcode':

          let isNum = /^\d+$/


          if(!this.smsbtn){
            if (this.formData.verifcode.length == 0 || this.formData.verifcode.length < 4) {
              this.formData.verifcodemsg = '請輸入驗證碼'
              this.formData.verifcodecheck = false
            }

            if (this.formData.verifcode.length == 4 ) {
              this.formData.verifcodemsg = ''
              this.formData.verifcodecheck = true
            }
            if (!isNum.test(this.formData.verifcode)) {
              this.formData.verifcodemsg = '請輸入數字驗證碼'
              this.formData.verifcodecheck = false
            }
          }else if( this.formData.usernamecheck){
            this.formData.verifcodemsg = '點擊取得認證簡訊'
            this.formData.verifcodecheck = false
          }

          break
        case 'username':
          if (this.formData.username.length == 0 || this.formData.username.length < 10) {
            this.formData.usernamemsg = '請填寫行動電話號碼'
            this.formData.usernamecheck = false
          }
          let isPhone = /^09\d{8}$/
          if (!isPhone.test(this.formData.username)) {
            this.formData.usernamemsg = '請填寫正確行動電話號碼'
            this.formData.usernamecheck = false
          }
          else {
            this.formData.usernamemsg = ''
            this.formData.usernamecheck = true
          }
          break
        case 'password':
          let isPwd = /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/
          let Password = this.formData.password
          if (Password.length < 6 || Password.length > 12 || !isPwd.test(Password)) {
            this.formData.passwordcheck = false
            this.formData.passwordmsg = '登錄密碼必須6-12位，包含數字+字母組合!'
          } else {
            this.formData.passwordcheck = true
          }
          break

      }

    },

    savePwd(){
      this.sendloading = true
      this.checkvalue('password')
      if (this.formData.passwordcheck == true) {
        this.$store.dispatch('actionPWD', {
          password: this.formData.password
        }).then((res) => {
          this.sendloading = false
          this.$store.dispatch('actionGetMemberInfo', {}).then((res) => {}).catch((res) => {})
        }).catch((res) => {
          this.sendloading = false
        })
      }

    }
  }
}
</script>
